'use strict';
import globals from './lib/globals';
import Logger from "./utilities/Logger";
import Elements from "./utilities/Elements";
import KeenSlider from 'keen-slider';
import Evts from "./utilities/Evts";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
// Bootstrap global functionality
globals();

const NAME = 'STUDIO';
Logger.log(NAME);

const history_section = {
	spin_button: Elements.id('spin_the_wheel_btn'),
	prizeWheel_1_scene: Elements.id('prizeWheel_1_scene'),
	prizeWheel_2_scene: Elements.id('prizeWheel_2_scene'),
	prizeWheel_ticker: Elements.id('PrizeWheel_TriangleTicker_cont'),
	prizeWheel_wheel: Elements.id('PrizeWheel_group'),
	prev_btn: Elements.id('prev_btn'),
	next_btn: Elements.id('next_btn'),
	year_slider: Elements.id('studio-history_slider'),
	years: null,
	years_slider_ref: null,
	timelineOnBottom: Elements.id('timeline'),
	timelineOnBottom_tl: null,
	chosen_year_content_carousels: []
};
const getWindowWidth = () => {
	return Math.max(
		document.body.scrollWidth,
		document.documentElement.scrollWidth,
		document.body.offsetWidth,
		document.documentElement.offsetWidth,
		document.documentElement.clientWidth
	);
};
let formfactor = 'd'
const questions = document.querySelectorAll('[data-faq-answer-toggle]');
const questionActiveClass = 'studio-faq-question--open';
const bubbleYPositions = [0, 226, 264, 97, 21, 226, 148];
gsap.set(history_section.timelineOnBottom, { autoAlpha: 0, force3D: true });
gsap.registerPlugin(ScrollTrigger, CustomEase);
CustomEase.create("timingFuncEaseOutBack", "0.175, 0.885, 0.320, 1.275");
CustomEase.create("timingFuncEaseOutBack3", "M0,0 C0.128,0.572 0.316,0.987 0.58,1.022 0.748,1.044 0.838,1 1,1 ");

//  View Controller
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
/**
 * init --- Initialize application.
 */
function init() {
	Logger.log(`${NAME} > init`);
	history_section.years = JSON.parse(history_section.year_slider.dataset.years);
	addHandlers();
	onResize();
	const carousels = document.getElementsByClassName('studio-history-chosen-year-content__slider');
	for (let index = 0; index < carousels.length; index++) {
		// console.log(carousels[index].id);
		let chosen_year_content = new KeenSlider(`#${carousels[index].id}`, {
			selector: '.studio-history-chosen-year-content__slider-slide',
			mode: "free-snap",
			loop: true,
			slides: {
				perView: 1,
				spacing: 0,
			},
			created: (slider) => {
				const collection1 = slider.container.previousElementSibling.getElementsByTagName("button");
				// convert to an array
				Array.from(collection1).forEach((headline_btn, idx) => {
					// console.info(headline_btn);
					headline_btn.addEventListener("click", (evt) => {
						slider.moveToIdx(idx);
					})
				});

				const collection2 = slider.container.nextElementSibling.getElementsByTagName("button");
				Array.from(collection2).forEach((dot, idx) => {
					// console.info(dot);
					dot.addEventListener("click", (evt) => {
						slider.moveToIdx(idx);
					})
				});
				updateSlider(slider);
			},
			slideChanged: (slider) => updateSlider(slider)
		});
		history_section.chosen_year_content_carousels.push(chosen_year_content);
	}
}

/**
 * Controls FAQ
 */
questions.forEach((question) => {

	question.addEventListener('click', (evt) => {
		questions.forEach((btn) => {
			btn.classList.remove(questionActiveClass);
			btn.getElementsByTagName('SPAN')[1].classList.remove('studio-faq-question__question-icon--open');
		});
		question.getElementsByTagName('SPAN')[1].classList.add('studio-faq-question__question-icon--open');
		question.classList.toggle(questionActiveClass);
	});
});

/**
 * updateSlider --- Update all slider styles to reflect changes
 */
function updateSlider(slider_instance) {
	if (!slider_instance) return;
	const slide = slider_instance.track.details.rel;

	const collection2 = slider_instance.container.nextElementSibling.getElementsByTagName("button");
	// console.log(collection2);

	const collection1 = slider_instance.container.previousElementSibling.getElementsByTagName("button");
	// convert to an array
	Array.from(collection1).forEach((headline_btn, idx) => {
		// console.info(headline_btn);)
		if (idx === slide) {
			headline_btn.classList.add("active");
			headline_btn.setAttribute('aria-selected', 'true');
			headline_btn.setAttribute('tabindex', '0');
		} else {
			headline_btn.classList.remove("active");
			headline_btn.setAttribute('aria-selected', 'false');
			headline_btn.setAttribute('tabindex', '-1');
		}
	});

	Array.from(collection2).forEach((dot, idx) => {
		if (idx === slide) {
			dot.classList.add("studio-history-chosen-year-content__pagination-dot--active");
			dot.setAttribute('aria-selected', 'true');
			dot.setAttribute('tabindex', '0');
		} else {
			dot.classList.remove("studio-history-chosen-year-content__pagination-dot--active");
			dot.setAttribute('aria-selected', 'false');
			dot.setAttribute('tabindex', '-1');
		}
	});
}

/**
 * addHandlers --- Add event handlers for view
 */
function addHandlers() {
	Logger.log(`${NAME} > addHandlers`);
	Evts.add(history_section.spin_button, 'mousedown', onSpin);
	Evts.add(history_section.prizeWheel_wheel, 'mousedown', onSpin);
	Evts.add(history_section.prev_btn, 'mousedown', onPrevNext);
	Evts.add(history_section.next_btn, 'mousedown', onPrevNext);
	Evts.addMultiple(history_section.timelineOnBottom, ['mouseover', 'mousedown', 'mouseout', 'mouseleave'], onTimelineDot);
	Evts.add(window, 'resize', onResize);
}

/**
 * onResize --- Monitor window resizing
 * @param evt
 */
function onResize(evt) {
	if (getWindowWidth() < 959) {
		history_section?.timelineOnBottom_tl?.scrollTrigger.disable();
		history_section?.timelineOnBottom_tl?.pause(0);
		formfactor = 'm';
	} else {
		history_section?.timelineOnBottom_tl?.scrollTrigger.enable();
		formfactor = 'd';
	}
}

/**
 * onTimelineDot --- History section > Controls achievement dot functionality on bottom timeline
 * @param evt
 */
function onTimelineDot(evt) {
	const target = evt.target;
	if (target && target.nodeName === "BUTTON") {
		// console.warn(target);
		switch (evt.type) {
			case 'mouseover':
				target.getElementsByTagName('DIV')[0].classList.add('studio-history__timeline-achievement-dot-bubble--fade-in');
				break;
			case 'mousedown':
				history_section.years_slider_ref.moveToIdx(history_section.years.indexOf(target.dataset.yr), false, { duration: 2400 });
				const highlightedItems = document.querySelectorAll(".studio-history__timeline-achievement-dot-bubble--hold");

				highlightedItems.forEach(function (bubble) {
					bubble.classList.remove('studio-history__timeline-achievement-dot-bubble--hold');
				});
				target.getElementsByTagName('DIV')[0].classList.add('studio-history__timeline-achievement-dot-bubble--hold');
				break
			default:
				target.getElementsByTagName('DIV')[0].classList.remove('studio-history__timeline-achievement-dot-bubble--fade-in');
		}
	} else {
		// when the next and previous buttons are selected
		if (evt.type === undefined) {
			// console.clear();
			// console.log(`${NAME} evt > ${evt}`);

			const dot = document.querySelectorAll(".studio-history__timeline-achievement-dot");
			dot.forEach(function (ach_dot) {
				const highlightedItems = document.querySelectorAll(".studio-history__timeline-achievement-dot-bubble--hold");

				highlightedItems.forEach(function (bubble) {

					if (bubble.closest('.studio-history__timeline-achievement-dot').getAttribute('data-yr') !== evt) bubble.classList.remove('studio-history__timeline-achievement-dot-bubble--hold');
				});

				if (ach_dot.getAttribute('data-yr') === evt) {
					// console.log(`${NAME} loop > ${ach_dot.getAttribute('data-yr')}`);
					ach_dot.querySelector(".studio-history__timeline-achievement-dot-bubble").classList.add('studio-history__timeline-achievement-dot-bubble--hold');
				}
			});

		}
	}
}

/**
 * onPrevNext --- History section > left and right arrows once the prize wheel scene has transitioned to scene 2
 * @param evt
 */
function onPrevNext(evt) {
	if (evt.target.id === 'prev_btn') history_section.years_slider_ref.prev();
	else history_section.years_slider_ref.next();


	// const randomYear = history_section.years.length * Math.random() | 0;
	// history_section.years_slider_ref.moveToIdx(history_section.years.indexOf(history_section.years[randomYear]), false, {duration: 900});
	// showHideYearContentSlider(history_section.years[randomYear]);
}

/**
 * onSpin --- History section > CTA to spin the wheel in scene 1
 * @param evt
 */
let onSpin = (evt) => {
	history_section.prizeWheel_wheel.classList.add('studio-history__prize-wheel-wheel--spin');
	history_section.prizeWheel_ticker.classList.add('studio-history__prize-wheel-ticker--spin');

	Evts.rm(history_section.spin_button, 'mousedown', onSpin);
	Evts.rm(history_section.prizeWheel_wheel, 'mousedown', onSpin);
	setTimeout(() => {
		new CopyScrambler('spin_the_wheel_span_btn', [document.querySelector('#spin_the_wheel_span_btn').dataset.spinAgainText]);
	}, 1490);

	setTimeout(() => {

		history_section.prizeWheel_1_scene.classList.add('studio-history__scene--fade-out');
		history_section.prizeWheel_2_scene.classList.add('studio-history__scene--fade-in');
		history_section.next_btn.classList.add('studio-history__advance-btn--fade-in');
		history_section.prev_btn.classList.add('studio-history__advance-btn--fade-in');
		setupHistorySectionScene2();
		Evts.add(history_section.spin_button, 'mousedown', (evt) => {
			const randomYear = history_section.years.length * Math.random() | 0;
			history_section.years_slider_ref.moveToIdx(history_section.years.indexOf(history_section.years[randomYear]), false, { duration: 900 });
			// showHideYearContentSlider(history_section.years[randomYear]);
		});
	}, 1500);

	setTimeout(() => {
		history_section.prev_btn.removeAttribute("disabled");
		history_section.next_btn.removeAttribute("disabled");
	}, 2200);
};

/**
 * setupHistorySectionScene2 --- History section > Gets everything prepped for scene 2 and transitions in scene 2 elements
 */
function setupHistorySectionScene2() {

	history_section.timelineOnBottom_tl = gsap.timeline({
		duration: .3,
		ease: "timingFuncEaseOutBack3",
		paused: true,
		// onStart: () => {
		// 		three_indexes_bkgd_gp.classList.add('background_group--rotate');
		// },
		scrollTrigger: {
			// markers: true,
			trigger: "#history",
			toggleActions: "restart reverse restart reverse",
			// First value trigger element, second viewport
			start: "-130px 65%",
			end: "100% 90%", // end starts at bottom of main nav
			onLeave: () => {
				Elements.id('timeline_line_left').classList.remove('studio-history__timeline-line-t--ready');
				Elements.id('timeline_line_right').classList.remove('studio-history__timeline-line-t--ready');
			}
			// onEnterBack: () => three_indexes_bkgd_gp.classList.add('background_group--rotate'),
			// onLeaveBack: () => three_indexes_bkgd_gp.classList.remove('background_group--rotate'),
		},
	});
	history_section.timelineOnBottom_tl.to(history_section.timelineOnBottom, {
		duration: .34,
		autoAlpha: 1
	});
	history_section.timelineOnBottom_tl.to('#timeline_line', {
		duration: .3,
		width: '100%'
	});
	history_section.timelineOnBottom_tl.to(['#timeline_line_left', '#timeline_line_right'], {
		duration: .34,
		height: 19,
		onComplete: () => {
			Elements.id('timeline_line_left').classList.add('studio-history__timeline-line-t--ready');
			Elements.id('timeline_line_right').classList.add('studio-history__timeline-line-t--ready');
		}
	});

	// Need to move to when second scened is revealed
	history_section.years_slider_ref = new KeenSlider("#studio-history_slider", {
		selector: '.studio-history__carousel-slider-slide',
		mode: "free-snap",
		loop: true,
		drag: false,
		slides: {
			origin: "center",
			perView: "auto",
			spacing: 0,
		},
		animationStarted: (sdr) => {
			for (const idxKey in sdr.slides) {
				sdr.slides[idxKey].classList.remove('studio-history__carousel-slider-slide--shadow-trans-in')
			}
		},
		animationEnded: (sdr) => {
			sdr.slides[sdr.track.details.rel].classList.add('studio-history__carousel-slider-slide--shadow-trans-in');
			const yr = sdr.slides[sdr.track.details.rel].getAttribute('data-yr');
			showHideYearContentSlider(yr);
			onTimelineDot(yr);
		}
	});

	const randomYear = history_section.years.length * Math.random() | 0;
	history_section.years_slider_ref.moveToIdx(history_section.years.indexOf(history_section.years[randomYear]), false, { duration: 2400 });
	if (getWindowWidth() < 959) onResize(null);
}

/**
 * showHideYearContentSlider --- History section > In scene 2, each year has a content slider/carousel. This hides all content carousels, shows the current year, and resets the slider to slide 1
 */
function showHideYearContentSlider(yr) {
	document.querySelectorAll('.studio-history-chosen-year-content__carousel').forEach((carousel) => {
		if (carousel.id.includes(`${yr}`)) {
			carousel.classList.add('studio-history-chosen-year-content__carousel--fade-in');
			// console.warn(yr, carousel.id)
		} else carousel.classList.remove('studio-history-chosen-year-content__carousel--fade-in');
	});

	history_section.chosen_year_content_carousels.forEach((carousel) => carousel.update());
}

/**
 * CopyScrambler --- History section > Scrambles copy on scene 1 CTA button when it makes transition to scene 2
 * @param el
 * @param msgs
 * @param endless
 * @constructor
 */
const CopyScrambler = function (el, msgs, endless = false) {
	const m = this;

	m.init = () => {
		m.el = document.getElementById(el);
		m.codeletters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890±!@#$%^&*()_+-=§£™¡¢∞§¶•–≠œ∑´®†¥¨ˆøπ“‘åß∂ƒ©¬…æ«`~Ω≈ç√∫˜µ≤≥÷₩¼";
		m.message = 0;
		m.current_length = 0;
		m.fadeBuffer = false;
		m.messages = msgs || [
			'Longer message here. Message 1.',
			'Secondary message.'
		];
		setTimeout(m.animateIn, 100);
	};

	m.generateRandomString = (length) => {
		let random_text = '';
		while (random_text.length < length) {
			random_text += m.codeletters.charAt(Math.floor(Math.random() * m.codeletters.length));
		}
		return random_text;
	};

	m.animateIn = () => {
		if (m.current_length < m.messages[m.message].length) {
			m.current_length = m.current_length + 2;
			if (m.current_length > m.messages[m.message].length) {
				m.current_length = m.messages[m.message].length;
			}
			m.el.innerHTML = m.generateRandomString(m.current_length);
			setTimeout(m.animateIn, 20);
		} else setTimeout(m.animateFadeBuffer, 20);
	};

	m.animateFadeBuffer = () => {
		let i;
		if (m.fadeBuffer === false) {
			m.fadeBuffer = [];
			for (i = 0; i < m.messages[m.message].length; i++) {
				m.fadeBuffer.push({ c: (Math.floor(Math.random() * 12)) + 1, l: m.messages[m.message].charAt(i) });
			}
		}

		let do_cycles = false;
		let message = '';

		for (i = 0; i < m.fadeBuffer.length; i++) {
			const fader = m.fadeBuffer[i];
			if (fader.c > 0) {
				do_cycles = true;
				fader.c--;
				message += m.codeletters.charAt(Math.floor(Math.random() * m.codeletters.length));
			} else message += fader.l;
		}

		m.el.innerHTML = message;

		if (do_cycles === true) setTimeout(m.animateFadeBuffer, 50);
		else setTimeout(m.cycleText, 2000);
	};

	m.cycleText = () => {
		m.message = m.message + 1;
		m.current_length = 0;
		m.fadeBuffer = false;

		if (m.message >= m.messages.length) {
			m.message = 0;
		} else {
			console.log(m.el.innerHTML);
			m.el.innerHTML = '';
			setTimeout(m.animateIn, 200);
		}
	};
	m.init();
}

/**
 * getOffsetRect --- Find an elements relative position
 * @param elem
 * @returns {{top: number, left: number, bottom: number, right: number}}
 */
function getOffsetRect(elem) {
	const box = elem.getBoundingClientRect();
	const body = document.body;
	const docElem = document.documentElement;
	const scrollTop = window.scrollY || docElem.scrollTop || body.scrollTop;
	const scrollLeft = window.scrollX || docElem.scrollLeft || body.scrollLeft;
	const clientTop = docElem.clientTop;
	const clientLeft = docElem.clientLeft;
	const top = box.top + scrollTop - clientTop;
	const left = box.left + scrollLeft - clientLeft;
	const bottom = top + (box.bottom - box.top);
	const right = left + (box.right - box.left);

	return {
		top: Math.round(top),
		left: Math.round(left),
		bottom: Math.round(bottom),
		right: Math.round(right),
	}
}

init();

